import { useReducer } from 'react';
import { TemplateCreateReducer } from './TemplateCreateReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  TemplateCreateDispatchContext,
  TemplateCreateStateContext,
} from './UseTemplateCreateContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface ITemplateListProviderProps {
  children: any;
  value?: IValue;
}

export function TemplateCreateProvider({
  children,
  value = { initialState: defaultContextValues, reducer: TemplateCreateReducer },
}: ITemplateListProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <TemplateCreateStateContext.Provider value={state}>
      <TemplateCreateDispatchContext.Provider value={dispatch}>{children}</TemplateCreateDispatchContext.Provider>
    </TemplateCreateStateContext.Provider>
  );
}
